export default __webpack_public_path__ + "static/media/presentIcon.fa46e7bf.svg";